import { Component, OnInit } from '@angular/core';

import { DocsService } from '../../services/docs.service';

@Component({
    selector: 'kd-version',
    templateUrl: './version.component.html',
    styleUrls: ['./version.component.scss']
})
export class VersionComponent implements OnInit {

    version: string;
    versions: Array<string>;

    constructor(
        private docsService: DocsService,
    ) { }

    ngOnInit() {
        this.init();
        this.docsService.getPageChange().subscribe(() => {
            this.init();
        });
    }

    private init(): void {
        this.version = this.docsService.getVersion();
        this.versions = this.docsService.getVersions();
    }

    onChange(): void {
        this.docsService.setVersion(this.version);
    }
}
